<template>
  <div>
    <v-col
      class="d-flex"
      cols="12"
      :md="clamp(Math.floor(12/filterCount), 3, 6)"
      :sm="clamp(Math.floor(12/filterCount), 4, 12)"
    >
      <v-select
        v-if="filterOptions && filterOptions.length > 0"
        v-model="Value"
        clearable
        chips
        deletable-chips
        :items="filterOptions"
        :label="filterName"
        multiple
        item-text="Text"
        item-value="Value"
        :menu-props="{ bottom: true, offsetY: true }"
        @input="sentChanged(filterKey, Value, fieldType)"
      />
      <v-text-field
        v-else
        v-model="Value"
        :type="fieldType == 'Integer Range' ? 'Number' : ''"
        clearable
        :label="filterName"
        @input="sentChanged(filterKey, Value, fieldType)"
      />
    </v-col>
  </div>
</template>

<script>

export default {
  components: {

  },
  props: {
    filterCount: {
      type: Number,
      required: true,
    },
    filterName: {
      type: String,
      required: true,
    },
    filterKey: {
      type: String,
      required: true,
    },
    fieldType: {
      type: String,
      default: '',
    },
    filterOptions: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    Value: '',
  }),
  methods: {
    clamp(num, min, max) { return Math.min(Math.max(num, min), max); },
    sentChanged(Key, Value, Type) {
      this.$emit('input', { Key, Value, Type });
    },
  },
};
</script>

<style>

</style>
